
namespace RioERP.Orders {
    import fld = OrdersRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class OrdersGrid extends Serenity.EntityGrid<OrdersRow, any> {
        protected getColumnsKey() { return 'Orders.Orders' }
        protected getDialogType() { return OrdersDialog; }
        protected getIdProperty() { return OrdersRow.idProperty; }
        protected getInsertPermission() { return OrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return OrdersRow.localTextPrefix; }
        protected getService() { return OrdersService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private FranchiseeId;
        private InvoiceId;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getQuickFilters() {

            var filters = super.getQuickFilters();

            let filter = Q.first(filters, x => x.field == fld.FranchiseeId);

            filter.handler = h => {

                if (h.active) {
                    this.FranchiseeId = h.value;
                    h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                        [[fld.FranchiseeId], '=', h.value]);
                }
                else {
                    this.FranchiseeId = null;
                }

            };
            //let filter2 = Q.first(filters, x => x.field == fld.InvoiceId);

            //filter2.handler = j => {
            //    debugger;
            //    // if filter is active, e.g. editor has some value
            //    if (j.active) {
            //        this.InvoiceId = j.value;
            //        j.request.Criteria = Serenity.Criteria.and(j.request.Criteria,
            //            [[fld.InvoiceId], '=', j.value]);

            //    }

            //};
            //Q.first(filters, x => x.field == fld.District).init = w => {
            //    // enum editor has a string value, so need to call toString()
            //    (w as Serenity.EnumEditor).value = "2"
            //};
            //Q.first(filters, x => x.field == fld.Center).init = w => {
            //    // enum editor has a string value, so need to call toString()
            //    (w as Serenity.EnumEditor).value = "25"
            //};
            return filters;

        }
        protected getButtons()
        {
            var buttons = super.getButtons();
            buttons.splice(1, 0);

            buttons.push({
                title: 'Short Order',
                cssClass: 'add-button',
                separator: true,
                onClick: () => {
                    var dialog = new OrdersForFranchiseeDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrdersService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Print Receipt',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length != 1) {
                        Q.alert("Please select single Order(s) to print Receipt");
                        return;
                    }
                    else {
                        var param = {
                            'OrderIds': rowKeys
                        };
                        //var url = "/PrintInvoice/PrintReceipt";
                        //this.OpenWindowWithPostData(url, "", "PrintLabels", param);
                        //window.location.href = Q.resolveUrl('~/PrintInvoice/PrintReceipt?OrderIds=' + rowKeys);
                        Q.postToService({ url: Q.resolveUrl('~/PrintInvoice/PrintReceipt?OrderIds=' + rowKeys), request: '', target: '_blank' });
                    }

                }
            });

            buttons.push({
                title: 'Print Address',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    //debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select atleast 1 Order to print Address!");
                        return;
                    }
                    else {
                        var param = {
                            'OrderIds': rowKeys
                        };                        
                        Q.postToService({ url: Q.resolveUrl('~/PrintInvoice/PrintAddress?OrderIds=' + rowKeys), request: '', target: '_blank' });
                    }
                }
            });

            buttons.push({
                title: 'Create Invoice',
                cssClass: 'add-button',
                separator: true,
                onClick: () => {
                    debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Invoices/Invoices/CreateInvoice', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });
            
            buttons.push({
                title: 'Single Franchisee Invoice',
                cssClass: 'add-button',
                separator: true,
                onClick: () => {
                    debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {

                        var filters = super.getQuickFilters();
                        let filter = Q.first(filters, x => x.field == fld.FranchiseeId);

                        filter.handler = h => {
                            debugger;
                            // if filter is active, e.g. editor has some value
                            if (h.active) {
                                debugger;
                                this.FranchiseeId = h.value;

                            }
                            else {
                                this.FranchiseeId = null;
                                this.rowSelection.resetCheckedAndRefresh();
                                this.refresh();
                                return;
                            }
                        };
                        if (this.FranchiseeId == null) {
                            Q.alert("Please Select Franchisee First");
                            this.rowSelection.resetCheckedAndRefresh();
                            this.refresh();
                            return;
                        }
                        Q.serviceRequest('/Services/Invoices/Invoices/CreateSingleFranchiseeInvoice', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                separator: true,
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new OrdersExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push({
                title: 'Download Order Sample',
                cssClass: 'export-xlsx-button',
                separator: true,
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Workspace/Orders/OrdersImportSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });

            buttons.push({
                title: 'Import From Excel For Shipping',
                cssClass: 'export-xlsx-button',
                separator: true,
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new OrdersShippingExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push({
                title: 'Download Order Shipping Sample',
                cssClass: 'export-xlsx-button',
                separator: true,
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Workspace/Orders/OrderShippingSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });

            buttons.push({
                title: 'Process Order',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        var param = {
                            'OrderIds': rowKeys
                        };

                        Q.serviceRequest('/Services/Orders/Orders/ProcessOrder', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh(), Q.notifySuccess("Serialkey generated successfully") });
                    }
                }
            });

            buttons.push({
                title: 'ReCalculate', cssClass: 'add-button', separator: true,
                onClick: () => {
                    debugger;

                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/Orders/ReCalculate', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                },
               
            });

            buttons.push({
                title: 'ReCalculate Franchisee', cssClass: 'add-button', separator: true,
                onClick: () => {
                    debugger;

                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/Orders/ReCalculateFranchisee', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            buttons.push({
                title: 'Assign Tracking Number',
                cssClass: 'add-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/OrderShipping/AssignTrackingNumbers', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            buttons.push({
                title: 'Send Email',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        new Orders.OrderEmailDialog(this, true, rowKeys.toString()).dialogOpen();
                    }
                }
            });

            buttons.push({
                title: 'Sync Order',
                cssClass: 'print-button',
                separator: true,
                onClick: () => {
                    new Orders.OrderWebhookDialog().dialogOpen();
                    
                }
            });

            buttons.push({
                title: 'Assign Delhivery Tracking', cssClass: 'add-button',
                onClick: () => {

                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/OrderShipping/AssignTrackingDelhivery', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });
            buttons.push({
                title: 'Assign DTDC Tracking', cssClass: 'add-button',
                onClick: () => {

                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.serviceRequest('/Services/Orders/OrderShipping/AssignTrackingDTDC', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });

            return buttons;
        }
        protected getItemCssClass(item: Orders.OrdersRow, index: number): string {
            let klass: string = "";
            if (item.EPaymentStatus == RioERP.Web.Enums.PaymentStatus.Pending)
                klass += " pending";

            if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Placed)
                klass += " placed";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Pending)
                klass += " pending";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Processing)
                klass += " processing";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Processed)
                klass += " processed";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Complete)
                klass += " complete";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Cancelled)
                klass += " cancelled";


            return Q.trimToNull(klass);
        }
    }
}